<template>
    <table class="table table-sm bordered-header">
        <thead>
            <tr>
                <th class="w-50">Hakediş Tarihi</th>
                <th class="w-50">Gün</th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="(v,i) in (value || [])" :key="i">
                <td>{{ $safe(v,'HakedisTarihiStr') || '' }}</td>
                <td>{{ $safe(v,'Gun') || '' }}</td>
            </tr>
            <tr v-if="(value || []).length == 0">
                <td colspan="2" class="text-center">Henüz bir hakediş bulunmamaktadır.</td>
            </tr>
        </tbody>
    </table>
</template>

<script>
export default {
    props:{
        value:Array
    }
}
</script>